import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({ 
  title, 
  description, 
  keywords, 
  canonical,
  ogImage,
  schemaData 
}) => {
  const defaultTitle = "DGM Property Management Calgary | Professional Property Management Services";
  const defaultDescription = "DGM Property Management offers comprehensive property management services in Calgary & Airdrie. Expert tenant placement, maintenance, and real estate investment solutions. Call 587-800-1215";
  const siteUrl = "https://dgmpropertymanagement.ca";
  
  const finalTitle = title ? `${title} | DGM Property Management` : defaultTitle;
  const finalDescription = description || defaultDescription;
  const finalCanonical = canonical ? `${siteUrl}${canonical}` : siteUrl;
  const finalOgImage = ogImage || "https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&h=630";

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      <meta name="keywords" content={keywords || "property management Calgary, property management Airdrie, tenant placement Calgary, real estate investment Calgary, property maintenance Calgary, rental management Alberta"} />
      <meta name="author" content="DGM Property Management" />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      
      {/* Open Graph Tags */}
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={finalCanonical} />
      <meta property="og:image" content={finalOgImage} />
      <meta property="og:site_name" content="DGM Property Management" />
      <meta property="og:locale" content="en_CA" />
      
      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={finalOgImage} />
      
      {/* Canonical Link */}
      <link rel="canonical" href={finalCanonical} />
      
      {/* JSON-LD Schema */}
      {schemaData && (
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;